import React from 'react';
import {Dummy} from '../';

export default class Electroentry extends Dummy {

    paintCanvas(cvs, disabled, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11, p12, p13, p14, p15, p16) {
        function KVright(power) {
            const canvas = document.getElementById('tmpcanvas');
            canvas.width = 53;
            canvas.height = 44;
            const ctx = canvas.getContext('2d');

            ctx.beginPath();
            ctx.arc(50, 22, 3, 0, Math.PI * 2, true);
            ctx.moveTo(47, 22);
            ctx.lineTo(25, 22);
            ctx.stroke();
            ctx.closePath();

            if (power === 0) {
                ctx.fillStyle = 'red';
            } else {
                ctx.fillStyle = 'green';
            }

            ctx.fillRect(0, 0, 25, 44);

            return canvas;
        }

        function KVleft(power) {
            const canvas = document.getElementById('tmpcanvas');
            canvas.width = 53;
            canvas.height = 44;
            const ctx = canvas.getContext('2d');

            ctx.beginPath();
            ctx.arc(3, 22, 3, 0, Math.PI * 2, true);
            ctx.moveTo(6, 22);
            ctx.lineTo(28, 22);
            ctx.stroke();
            ctx.closePath();

            if (power === 0) {
                ctx.fillStyle = 'red';
            } else {
                ctx.fillStyle = 'green';
            }

            ctx.fillRect(28, 0, 25, 44);

            return canvas;
        }

        function pump() {
            const canvas = document.getElementById('tmpcanvas');
            canvas.width = 46;
            canvas.height = 46;
            const ctx = canvas.getContext('2d');

            ctx.beginPath();
            ctx.arc(23, 23, 22, 0, Math.PI * 2, true);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.arc(23, 23, 14, 0, Math.PI * 2, true);
            ctx.stroke();
            ctx.closePath();

            return canvas;
        }

        function teren() {
            const canvas = document.getElementById('tmpcanvas');
            canvas.width = 10;
            canvas.height = 145;
            const ctx = canvas.getContext('2d');

            ctx.beginPath();
            ctx.moveTo(9, 0);
            ctx.lineTo(9, 45);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.arc(9, 54, 9, Math.PI / 2, Math.PI * 3 / 2, false);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.arc(9, 72, 9, Math.PI / 2, Math.PI * 3 / 2, false);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.arc(9, 90, 9, Math.PI / 2, Math.PI * 3 / 2, false);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.moveTo(9, 99);
            ctx.lineTo(9, 110);
            ctx.stroke();
            ctx.closePath();

            return canvas;
        }

        function KM(power) {
            const canvas = document.getElementById('tmpcanvas');
            canvas.width = 26;
            canvas.height = 57;
            const ctx = canvas.getContext('2d');

            ctx.beginPath();
            ctx.fillStyle = 'white';
            ctx.arc(21, 3, 3, 0, Math.PI * 2, true);
            ctx.fill();
            ctx.lineWidth = 1;
            ctx.strokeStyle = 'black';
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.moveTo(21, 6);
            ctx.lineTo(21, 13);
            ctx.lineTo(16, 13);
            ctx.lineTo(26, 13);
            ctx.lineTo(21, 13);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.fillStyle = 'white';
            ctx.arc(21, 53, 3, 0, Math.PI * 2, true);
            ctx.fill();
            ctx.lineWidth = 1;
            ctx.strokeStyle = 'black';
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.moveTo(21, 50);
            ctx.lineTo(21, 43);
            ctx.stroke();
            ctx.closePath();


            ctx.beginPath();
            if (power === 1) {
                ctx.beginPath();
                ctx.moveTo(21, 43);
                ctx.lineTo(21, 13);
                ctx.strokeStyle = 'red';
                ctx.stroke();
                ctx.closePath();
            } else {
                ctx.beginPath();
                ctx.moveTo(21, 43);
                ctx.lineTo(0, 16);
                ctx.strokeStyle = 'green';
                ctx.stroke();
                ctx.closePath();
            }
            ctx.stroke();

            return canvas;
        }

        function KM_1(c1, c2) {
            const canvas = document.getElementById('tmpcanvas');
            canvas.width = 26;
            canvas.height = 57;
            const ctx = canvas.getContext('2d');

            ctx.beginPath();
            ctx.fillStyle = 'white';
            ctx.arc(21, 3, 3, 0, Math.PI * 2, true);
            ctx.fill();
            ctx.lineWidth = 1;
            ctx.strokeStyle = 'black';
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.moveTo(21, 6);
            ctx.lineTo(21, 13);
            ctx.lineTo(16, 13);
            ctx.lineTo(26, 13);
            ctx.lineTo(21, 13);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.fillStyle = 'white';
            ctx.arc(21, 53, 3, 0, Math.PI * 2, true);
            ctx.fill();
            ctx.lineWidth = 1;
            ctx.strokeStyle = 'black';
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.moveTo(21, 50);
            ctx.lineTo(21, 43);
            ctx.stroke();
            ctx.closePath();


            ctx.beginPath();
            if (c1 === 0 && c2 === 0) {
                ctx.beginPath();
                ctx.moveTo(21, 43);
                ctx.lineTo(21, 13);
                ctx.strokeStyle = 'red';
                ctx.stroke();
                ctx.closePath();
            } else if (c1 === 0 && c2 === 1) {
                ctx.beginPath();
                ctx.moveTo(21, 43);
                ctx.lineTo(21, 13);
                ctx.strokeStyle = 'red';
                ctx.stroke();
                ctx.closePath();
            } else if (c1 === 1 && c2 === 0) {
                ctx.beginPath();
                ctx.moveTo(21, 43);
                ctx.lineTo(0, 16);
                ctx.strokeStyle = 'green';
                ctx.stroke();
                ctx.closePath();
            } else if (c1 === 1 && c2 === 1) {
                ctx.beginPath();
                ctx.moveTo(21, 43);
                ctx.lineTo(0, 16);
                ctx.strokeStyle = 'green';
                ctx.stroke();
                ctx.closePath();
            } else {
                ctx.beginPath();
                ctx.moveTo(21, 43);
                ctx.lineTo(21, 13);
                ctx.strokeStyle = 'black';
                ctx.stroke();
                ctx.closePath();
            }
            ctx.stroke();

            return canvas;
        }

        function KM_2(c1, c2) {
            const canvas = document.getElementById('tmpcanvas');
            canvas.width = 26;
            canvas.height = 57;
            const ctx = canvas.getContext('2d');

            ctx.beginPath();
            ctx.fillStyle = 'white';
            ctx.arc(21, 3, 3, 0, Math.PI * 2, true);
            ctx.fill();
            ctx.lineWidth = 1;
            ctx.strokeStyle = 'black';
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.moveTo(21, 6);
            ctx.lineTo(21, 13);
            ctx.lineTo(16, 13);
            ctx.lineTo(26, 13);
            ctx.lineTo(21, 13);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.fillStyle = 'white';
            ctx.arc(21, 53, 3, 0, Math.PI * 2, true);
            ctx.fill();
            ctx.lineWidth = 1;
            ctx.strokeStyle = 'black';
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.moveTo(21, 50);
            ctx.lineTo(21, 43);
            ctx.stroke();
            ctx.closePath();


            ctx.beginPath();
            if (c1 === 0 && c2 === 0) {
                ctx.beginPath();
                ctx.moveTo(21, 43);
                ctx.lineTo(0, 16);
                ctx.strokeStyle = 'green';
                ctx.stroke();
                ctx.closePath();
            } else if (c1 === 0 && c2 === 1) {
                ctx.beginPath();
                ctx.moveTo(21, 43);
                ctx.lineTo(0, 16);
                ctx.strokeStyle = 'green';
                ctx.stroke();
                ctx.closePath();
            } else if (c1 === 1 && c2 === 0) {
                ctx.beginPath();
                ctx.moveTo(21, 43);
                ctx.lineTo(21, 13);
                ctx.strokeStyle = 'red';
                ctx.stroke();
                ctx.closePath();
            } else if (c1 === 1 && c2 === 1) {
                ctx.beginPath();
                ctx.moveTo(21, 43);
                ctx.lineTo(0, 16);
                ctx.strokeStyle = 'green';
                ctx.stroke();
                ctx.closePath();
            } else {
                ctx.beginPath();
                ctx.moveTo(21, 43);
                ctx.lineTo(21, 13);
                ctx.strokeStyle = 'black';
                ctx.stroke();
                ctx.closePath();
            }
            ctx.stroke();

            return canvas;
        }

        function QF() {
            const canvas = document.getElementById('tmpcanvas');
            canvas.width = 26;
            canvas.height = 57;
            const ctx = canvas.getContext('2d');

            ctx.beginPath();
            ctx.fillStyle = 'white';
            ctx.arc(21, 3, 3, 0, Math.PI * 2, true);
            ctx.fill();
            ctx.lineWidth = 1;
            ctx.strokeStyle = 'black';
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.moveTo(21, 6);
            ctx.lineTo(21, 13);
            ctx.lineTo(16, 13);
            ctx.lineTo(26, 13);
            ctx.lineTo(21, 13);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.fillStyle = 'white';
            ctx.arc(21, 53, 3, 0, Math.PI * 2, true);
            ctx.fill();
            ctx.lineWidth = 1;
            ctx.strokeStyle = 'black';
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.moveTo(21, 50);
            ctx.lineTo(21, 43);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();
            ctx.moveTo(21, 43);
            ctx.lineTo(21, 33);
            ctx.lineTo(16, 33);
            ctx.lineTo(16, 23);
            ctx.lineTo(21, 23);
            ctx.lineTo(21, 13);
            ctx.lineTo(21, 50);
            ctx.strokeStyle = 'black';
            ctx.stroke();
            ctx.closePath();
            // if (power===1) {
            // 		ctx.beginPath();
            //    ctx.moveTo(21,43);
            //    ctx.lineTo(21,33);
            //    ctx.lineTo(16,33);
            //    ctx.lineTo(16,23);
            //    ctx.lineTo(21,23);
            //    ctx.lineTo(21,13);
            //    ctx.lineTo(21,50);
            //    ctx.strokeStyle = "red";
            //    ctx.stroke();
            //    ctx.closePath();
            // } else {
            // 		ctx.beginPath();
            //    ctx.moveTo(21,43);
            //    ctx.lineTo(7,25);
            //    ctx.lineTo(3,28);
            //    ctx.lineTo(10,37);
            //    ctx.lineTo(14,34);
            //    ctx.lineTo(0,16);
            //    ctx.strokeStyle = "green";
            //    ctx.stroke();
            //    ctx.closePath();
            // }
            ctx.stroke();
            return canvas;
        }

        function WattMetrLeft(c1) {
            const canvas = document.getElementById('tmpcanvas');
            canvas.width = 74;
            canvas.height = 56;
            const ctx = canvas.getContext('2d');


            ctx.fillStyle = 'black';
            ctx.font = '10px Arial';
            ctx.fillText('PI-1', 5, 10);

            if (c1 === 1) {
                ctx.fillStyle = 'red';
                ctx.beginPath();
                ctx.moveTo(63, 2);
                ctx.lineTo(73, 16);
                ctx.lineTo(63, 32);
                ctx.lineTo(63, 2);
                ctx.fill();
                ctx.closePath();
            } else {
                ctx.fillStyle = 'green';
                ctx.beginPath();
                ctx.moveTo(63, 2);
                ctx.lineTo(73, 16);
                ctx.lineTo(63, 32);
                ctx.lineTo(63, 2);
                ctx.fill();
                ctx.closePath();
            }
            ctx.strokeStyle = 'green';
            ctx.lineWidth = 1;
            ctx.strokeRect(0, 0, 60, 35);


            return canvas;
        }

        function WattMetrRight(c1) {
            const canvas = document.getElementById('tmpcanvas');
            canvas.width = 74;
            canvas.height = 56;
            const ctx = canvas.getContext('2d');


            ctx.fillStyle = 'black';
            ctx.font = '10px Arial';
            ctx.fillText('PI-2', 17, 10);


            if (c1 === 1) {
                ctx.fillStyle = 'red';
                ctx.beginPath();
                ctx.moveTo(0, 16);
                ctx.lineTo(10, 2);
                ctx.lineTo(10, 32);
                ctx.lineTo(0, 16);
                ctx.fill();
                ctx.closePath();
            } else {
                ctx.fillStyle = 'green';
                ctx.beginPath();
                ctx.moveTo(0, 16);
                ctx.lineTo(10, 2);
                ctx.lineTo(10, 32);
                ctx.lineTo(0, 16);
                ctx.fill();
                ctx.closePath();
            }
            ctx.strokeStyle = 'green';
            ctx.lineWidth = 1;
            ctx.strokeRect(13, 0, 60, 35);

            return canvas;
        }


        const canvas = document.getElementById(cvs);
        const ctx = canvas.getContext('2d');
        ctx.lineWidth = 1;
        ctx.fillStyle = '#C5C5C4';// grey big rects
        ctx.fillRect(0, 0, 590, 291);

        ctx.fillStyle = '#C5C5C4';// grey rects
        ctx.fillRect(0, 368, 90, 286);
        ctx.fillRect(500, 368, 90, 286);

        ctx.fillStyle = 'black';// triangle pi-1
        ctx.beginPath();
        ctx.moveTo(44, 1);
        ctx.lineTo(39, 9);
        ctx.lineTo(49, 9);
        ctx.lineTo(44, 1);
        ctx.fill();
        ctx.closePath();
        ctx.beginPath();// triangle pi-2
        ctx.moveTo(544, 1);
        ctx.lineTo(539, 9);
        ctx.lineTo(549, 9);
        ctx.lineTo(544, 1);
        ctx.fill();
        ctx.closePath();
        ctx.drawImage(WattMetrLeft(p1), 14, 10); // pi-1
        ctx.drawImage(WattMetrRight(p2), 501, 10);// pi-2

        ctx.beginPath();// line down from pi-1
        ctx.moveTo(44, 45);
        ctx.lineTo(44, 49);
        ctx.stroke();
        ctx.closePath();

        ctx.fillRect(20, 49, 48, 6);// шины
        ctx.fillRect(41, 99, 48, 6);
        ctx.fillRect(83, 199, 422, 6);
        ctx.fillRect(499, 99, 48, 6);
        ctx.fillRect(520, 49, 48, 6);


        ctx.drawImage(QF(), 23, 49);// qs1
        ctx.drawImage(QF(), 65, 99);// qf1
        ctx.drawImage(KM_1(p3, p4), 65, 149);// km1

        ctx.beginPath();// line from km1 to kv1
        ctx.moveTo(89, 152);
        ctx.lineTo(130, 152);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(KVleft(p5), 130, 130);// kv1


        ctx.drawImage(QF(), 116, 199);// 1qf-9qf
        ctx.drawImage(QF(), 172, 199);
        ctx.drawImage(QF(), 245, 199);
        ctx.drawImage(QF(), 301, 199);
        ctx.drawImage(QF(), 374, 199);
        ctx.drawImage(QF(), 430, 199);

        ctx.drawImage(KM_2(p6, p7), 481, 149);// km2

        ctx.beginPath();// line from km2 to kv2
        ctx.moveTo(499, 152);
        ctx.lineTo(458, 152);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(KVright(p8), 405, 130);// kv2
        ctx.drawImage(QF(), 481, 99);// qf2
        ctx.drawImage(QF(), 523, 49);// qs2
        ctx.beginPath();// line down from pi-2
        ctx.moveTo(544, 45);
        ctx.lineTo(544, 49);
        ctx.stroke();
        ctx.closePath();

        ctx.beginPath();// line down from qs1
        ctx.moveTo(44, 105);
        ctx.lineTo(44, 433);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(QF(), 23, 433);// ab
        ctx.drawImage(KM(p9), 23, 483);// km
        ctx.drawImage(teren(), 35, 539);// teren-100

        ctx.beginPath();// line down from qs2
        ctx.moveTo(544, 105);
        ctx.lineTo(544, 433);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(QF(), 523, 433);// ab
        ctx.drawImage(KM(p10), 523, 483);// km
        ctx.drawImage(teren(), 535, 539);// teren-100

        ctx.fillStyle = '#C5C5C4';// квадраты
        ctx.fillRect(114, 368, 102, 66);
        ctx.fillRect(243, 368, 102, 66);
        ctx.fillRect(372, 368, 46, 66);
        ctx.fillRect(428, 368, 46, 66);

        ctx.beginPath();// line down from 1qf
        ctx.moveTo(137, 255);
        ctx.lineTo(137, 373);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(KM(p11), 116, 373);// 1km shatnc1
        ctx.beginPath();// line down from km
        ctx.moveTo(137, 429);
        ctx.lineTo(137, 544);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(pump(), 114, 544);// pump 1

        ctx.beginPath();// line down from 2qf
        ctx.moveTo(193, 255);
        ctx.lineTo(193, 373);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(KM(p12), 172, 373);// 2km shatnc1
        ctx.beginPath();// line down from km
        ctx.moveTo(193, 429);
        ctx.lineTo(193, 544);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(pump(), 170, 544);// pump 2

        ctx.beginPath();// line down from 3qf
        ctx.moveTo(266, 255);
        ctx.lineTo(266, 373);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(KM(p13), 245, 373);// 3km shatnc2
        ctx.beginPath();// line down from km
        ctx.moveTo(266, 429);
        ctx.lineTo(266, 544);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(pump(), 243, 544);// pump 3

        ctx.beginPath();// line down from 4qf
        ctx.moveTo(322, 255);
        ctx.lineTo(322, 373);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(KM(p14), 301, 373);// 4km shatnc2
        ctx.beginPath();// line down from km
        ctx.moveTo(322, 429);
        ctx.lineTo(322, 544);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(pump(), 299, 544);// pump 4

        ctx.beginPath();// line down from 8qf
        ctx.moveTo(395, 255);
        ctx.lineTo(395, 373);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(KM(p15), 374, 373);// km shuv1
        ctx.beginPath();// line down from km
        ctx.moveTo(395, 429);
        ctx.lineTo(395, 544);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(pump(), 372, 544);// v2

        ctx.beginPath();// line down from 9qf
        ctx.moveTo(451, 255);
        ctx.lineTo(451, 373);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(KM(p16), 430, 373);// km shuv2
        ctx.beginPath();// line down from km
        ctx.moveTo(451, 429);
        ctx.lineTo(451, 544);
        ctx.stroke();
        ctx.closePath();
        ctx.drawImage(pump(), 428, 544);// v2
    }

    render() {
        return (
            <div className="col-md-7">
                <canvas className="cvs" id={this.props.canvas_id} width="590" height="654"/>
                <canvas className="hidden" id="tmpcanvas"/>
            </div>
        );
    }
}

Electroentry.propTypes = {
    ps: React.PropTypes.array.isRequired,
    canvas_id: React.PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/entries/Electroentry/index.jsx